export function setCellars(state, cellars) {
    state.cellars = cellars;
}

export function setCellar(state, cellar) {
    state.cellar = cellar;
}

